import { UserOrganizationRole } from "../API";
import { OrganizationFull } from "../models";

// Mirrors app/lib/utils/auth_groups.dart — keep both in sync.

const getRole = (
  organizationId: string,
  role: UserOrganizationRole,
  bookkeepingId?: string
) => [organizationId, bookkeepingId, role].filter(Boolean).join("-");

const getAccountantAuthGroups = (organization: OrganizationFull) =>
  (organization.authGroupsRead ?? []).filter((group) =>
    group.includes(UserOrganizationRole.accountant)
  );

// [<Organization Id>-accountant, <Organization Id>-admin]
export const getTransactionAuthGroups = (organization: OrganizationFull) => [
  ...getAccountantAuthGroups(organization),
  getRole(organization.id, UserOrganizationRole.admin),
];

// [<Organization Id>-<Bookkeeping Id>-head]
export const getTransactionAuthGroupsRead = (
  organizationId: string,
  bookkeepingId: string
) => [getRole(organizationId, UserOrganizationRole.head, bookkeepingId)];

// Tax and Attachment records use the same groups as Transaction
export const getTaxAuthGroups = getTransactionAuthGroups;
export const getTaxAuthGroupsRead = getTransactionAuthGroupsRead;
